
import { Component, Vue, Watch } from 'vue-property-decorator';
import { iHotGameDetails, iHotGameSearch, iSelectValueString, iSort } from '@/interface/hot-game';
import { getHotGameTypeList } from '@/api/hot-game-type';
import { iHotTypeGame, eEndPoint } from '@/interface/hot-game';
import { getHotGame, setSort, delHotGame, setRelease } from '@/api/android';
import { iUploadeImagesList } from '@/interface/imageUpload';
import ShowPreview from '@/views/android/hot-game/show_preview.vue';
import Edit from './edit.vue';
import { toast } from '@/utils/common';
@Component({
  components: { Edit, ShowPreview },
})
export default class HotGame extends Vue {
  // publicQuery = new PublicQuery();
  detailsTable: iHotGameDetails[] = []; //列表详情
  loading: boolean = false;
  dialogVisible: boolean = false; //新增。修改
  dialogPreviewVisible: boolean = false; //预览
  hotGameTypeList: iHotTypeGame[] = []; //热门游戏分类
  checkGameIndex: number = 0; //热门游戏分类选择的idndex
  endpoint: eEndPoint = 0; //是android (1)还是web(2)
  kind_id: number = 0; //热门游戏类型ID
  search_type: number = 1; //是否选择了热门游戏分类 1，选择，0 未选中
  model: iHotGameDetails = {
    id: -1,
    top_title: '',
    sub_title: '',
    game_id: -1,
    act_free: false, //是否免账号
    in_screen: true, //是否通屏
    remark: '',
    enter_img: '',
    enter_img2: '',
    main_img: '',
    game_media: [],
    kind_id: this.checkGameIndex,
    endpoint: this.endpoint,
  };
  ActFree: number = -1;
  total: number = 0;
  exitTitle: string = '新增';
  searchInfo: iHotGameSearch = {
    title: '',
    game_name: '',
    // game_type_id: 0,
    page: 1,
    size: 10,
    endpoint: this.endpoint,
    kind_id: this.checkGameIndex,
  };
  actFreeList: iSelectValueString[] = [
    {
      label: '是否免账号',
      value: -1,
    },
    {
      label: '是',
      value: 2,
    },
    {
      label: '否',
      value: 1,
    },
  ];
  enterImgUpload: iUploadeImagesList[] = [];
  enterImg2Upload: iUploadeImagesList[] = [];
  /* 查询 */
  searchList() {
    this.searchInfo.page = 1;
    this.search_type = 0; //用户点击查询按钮后默认选择类型为空
    this.getList();
  }
  /* 特殊查询（根据分类类型查询） */
  searchByType(page = 0) {
    this.search_type = 1;
    // console.log(page, '333333');

    if (page > 0) {
      this.searchInfo.page = page;
    }
    this.getList();
  }
  /* 编辑 */
  editRow(row: iHotGameDetails) {
    this.clear();
    this.dialogVisible = true;
    this.model = row;
    this.setUpload();
    // console.log(this.model);
    this.exitTitle = '编辑';
  }
  addHotGame() {
    if (this.checkGameIndex <= 0) {
      toast('请选择分类再添加热门游戏', 'error');
      return;
    }
    this.clear();
    // console.log('新增');
    // console.log(this.model);
    this.dialogVisible = true;
    this.exitTitle = '新增';
  }
  // disableHandle(row: iHotGameDetails) {
  //   this.$msgbox({
  //     title: '请确认是否要禁用当前渠道链接？',
  //     type: 'warning',
  //     showCancelButton: true,
  //     confirmButtonText: '确定',
  //     cancelButtonText: '取消',
  //     beforeClose: async (action, instance, done) => {
  //       if (action === 'confirm') {
  //         instance.confirmButtonLoading = true;
  //         instance.confirmButtonText = '执行中...';
  //         //
  //         done();
  //         instance.confirmButtonLoading = false;
  //       } else if (action === 'cancel') {
  //         done();
  //       }
  //     },
  //   }).then(action => {});
  // }
  /* 预览 */
  showPreview() {
    this.dialogPreviewVisible = !this.dialogPreviewVisible;
    if (this.kind_id == 0 && this.hotGameTypeList.length > 0) {
      this.kind_id = this.hotGameTypeList[0].id;
    }
  }
  handleSizeChange(size: number) {
    this.searchInfo.page = 1;
    this.searchInfo.size = size;
    this.getList();
  }
  handleCurrentChange(page: number) {
    this.searchInfo.page = page;
    this.getList();
  }
  async getList() {
    this.loading = true;
    try {
      // console.log(this.search_type, 'search_type');
      if (this.search_type == 1) {
        this.searchInfo.kind_id = this.checkGameIndex > 0 ? this.checkGameIndex : 0;
      } else {
        this.searchInfo.kind_id = 0;
        this.checkGameIndex = -1;
      }
      // console.log(this.searchInfo);
      const res = await getHotGame(this.searchInfo);
      this.detailsTable = [];
      if (res && res.code == 0) {
        this.detailsTable = res.data.rows;
        this.total = res.data.count;
        this.loading = false;
      }
    } catch (err) {
      this.loading = false;
      console.log(err);
    }
  }
  /* 排序 */
  async upSort(row: any, sort: string) {
    if (this.checkGameIndex <= 0) {
      toast('请选择相同分类进行排序!', 'error');
      return;
    }
    let sortItem: iSort = {
      id: row.id || -1,
      sort: sort,
      version: row.version || -1,
    };
    try {
      const res = await setSort(sortItem);

      if (res && res.code == 0) {
        toast('操作成功');
        this.loading = false;
        this.searchByType();
        // this.searchList();
      }
    } catch (err) {
      this.loading = false;
      console.log(err);
      if (err && err.code == 3) {
        this.searchByType();
        // this.searchList();
      }
    }
  }
  /* 删除 */
  async removeRow(row: any) {
    this.$msgbox({
      title: '提示',
      message: '是否确认删除，删除后，需要发布才能生效!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      beforeClose: async (action, instance, done) => {
        if (action === 'confirm') {
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = '执行中...';
          this.loading = true;
          const obj = [row.id, row.version];
          const res: any = await delHotGame(obj);
          done();
          if (res && res.code == 0) {
            toast('操作成功');
            this.loading = false;

            this.searchByType(1);
          }
          instance.confirmButtonLoading = false;
          this.loading = false;
        } else if (action === 'cancel') {
          //    alert(action);
          done();
          instance.confirmButtonLoading = false;
          this.loading = false;
        }
      },
    })
      .then(() => {})
      .catch((err: any) => {
        console.log(err);
      })
      .finally(() => {
        this.loading = false;
      });
  }
  /* 发布 */
  publishHotGame() {
    this.$msgbox({
      title: '提示',
      message: '请仔细预览效果和配置信息无误，确认发布吗？',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      beforeClose: async (action, instance, done) => {
        if (action === 'confirm') {
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = '执行中...';
          this.loading = true;
          const res: any = await setRelease(this.endpoint);
          done();
          if (res.code == 0) {
            toast('发布成功');
          } else {
            toast(res.msg, 'error');
          }
          instance.confirmButtonLoading = false;
          this.loading = false;
        } else if (action === 'cancel') {
          done();
          instance.confirmButtonLoading = false;
          this.loading = false;
        }
      },
    })
      .then(action => {})
      .catch(err => {
        console.log(err);
      });
  }
  ChangeSelect(value: any) {
    if (value != '-1') {
      this.searchInfo.act_free = value;
    } else {
      delete this.searchInfo.act_free;
    }
    this.searchList();
  }
  clear() {
    this.model = {
      id: -1,
      top_title: '',
      sub_title: '',
      game_id: -1,
      act_free: false, //是否免账号
      in_screen: true, //是否通屏
      remark: '',
      enter_img: '',
      enter_img2: '',
      main_img: '',
      game_media: [],
      kind_id: this.checkGameIndex,
      endpoint: this.endpoint,
    };
    this.enterImgUpload = [];
    this.enterImg2Upload = [];
  }
  editOk() {
    this.clear();
    this.getList();
    this.dialogVisible = false;
  }
  setUpload() {
    /* 非新增赋值 */
    if (this.model.id && this.model.id > 0) {
      this.enterImgUpload = [
        {
          url: this.model.enter_img,
        },
      ];
      this.enterImg2Upload = [
        {
          url: this.model.enter_img2 || '',
        },
      ];
    }
  }
  /* 游戏类别 */
  async getGameTypeList() {
    const query = {
      page: 1,
      size: 100,
      endpoint: this.endpoint,
      search: '',
    };

    const res = await getHotGameTypeList(query);

    //console.log('游戏类别');
    if (res) {
      this.hotGameTypeList = res.data.kinds;

      if (this.checkGameIndex <= 0 && this.hotGameTypeList.length > 0) {
        this.checkGameIndex = this.hotGameTypeList[0].id == undefined ? 0 : this.hotGameTypeList[0].id;
        this.searchInfo.kind_id = this.checkGameIndex;
        this.model.kind_id = this.checkGameIndex;
      }
      this.getList();
    }
  }
  getKindName(id: any) {
    if (!id) {
      return;
    }
    const item = this.hotGameTypeList.find((item: any) => item.id == id);
    return item ? item.title : '';
  }
  goGameTypeList() {
    this.$router.push('hot-game-type');
  }
  setParm() {
    this.endpoint = this.$route.meta!.type;
    this.model.endpoint = this.endpoint;
    this.searchInfo.endpoint = this.endpoint;
    this.search_type = 1;
    // console.log('endpoint', this.endpoint);
    this.getGameTypeList();
  }
  mounted() {
    this.setParm();
  }
  @Watch('$route.meta.type')
  onChangeValue(newVal: number, oldVal: number) {
    if (newVal != oldVal) {
      this.checkGameIndex = 0;
      this.searchInfo.page = 1;
      this.setParm();
    }
  }
}
